<template>
  <news-details-wrapper :article-type="StrapiArticleType.Blog" />
</template>

<script lang="ts" setup>
import { StrapiArticleType } from '#variant/apollo/types/types';

defineOptions({
  name: 'NewsBlogPage',
});

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    de: '/blog/[slug]',
    en: '/blog/[slug]',
    pt: '/blog/[slug]',
    fr: '/blog/[slug]',
    nl: '/blog/[slug]',
    it: '/blog/[slug]',
    ja: '/blog/[slug]',
    pl: '/blog/[slug]',
    // ru: '/blog/[slug]',
    es: '/blog/[slug]',
    zh: '/blog/[slug]',
  },
});
</script>
